import { render } from "./Sticky.vue?vue&type=template&id=1244ddb0"
import script from "./Sticky.vue?vue&type=script&lang=js"
export * from "./Sticky.vue?vue&type=script&lang=js"
script.render = render

export default script